import Vacancies from "./vacancies";

export default Vacancies;
